export default __webpack_public_path__ + "static/media/SOLDER_GENERIC_XLG.3bdf8d75.png";